module.exports = __webpack_public_path__ + "static/img/logo_meanwell.4c453ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_meanwell.jpg
// module id = mNjv
// module chunks = 1